<template>
    <v-menu
        bottom
        min-width="300"
    >
        <template v-slot:activator="{ on }">
            <icon-button x-small :on="on">mdi-menu-down</icon-button>
        </template>
        <div
            class="white pa-4 d-flex align-center"
            style="border-radius: 4px"
        >
            <div class="mr-1">
                <div
                    v-for="(row, index) in rows"
                    :key="index"
                    class="n3--text text-right body-2"
                    style="white-space: nowrap"
                >
                    {{ row.title }}:
                </div>
            </div>
            <div>
                <div
                    v-for="(row, index) in rows"
                    :key="index"
                    class="body-2"
                    style="white-space: nowrap"
                >
                    {{ row.value }}
                </div>
            </div>
        </div>
    </v-menu>
</template>

<script>
import { computed } from "@vue/composition-api";
import { $t } from "@/i18n";
import allowedEmailLogVisibleHeaders from "@/config/emailing/allowedEmailLogVisibleHeaders.json"
import { formatDateTime } from "@/plugins/formatting"

export default {
    name: "EmailDetails",
    props: {
        emailLog: {
            type: Object,
            required: true
        }
    },
    setup(props) {
        const rows = computed(() => {
            let visibleRows = []

            for (const key of Object.keys(props.emailLog.msg)) {
                let value = props.emailLog.msg[key]

                if (key === 'Date') {
                    value = formatDateTime(value)
                }

                if (value && allowedEmailLogVisibleHeaders.includes(key)) {
                    visibleRows.push({
                        title: key.toLowerCase(),
                        value: value
                    })
                }
            }

            return visibleRows
        })

        return {
            rows
        };
    }
};
</script>